import script from "./DesktopFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopFooter.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopFooter.vue?vue&type=style&index=0&id=7be8f740&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be8f740"]])

export default __exports__